import { createContext, ReactNode, useState } from 'react'
import BatchSnapshot from '../types/BatchSnapshot'

type ContextType = {
  previewBatch?: BatchSnapshot[]
  setPreviewBatch: (batch?: BatchSnapshot[]) => void
}

type ProviderProps = {
  children: ReactNode
}

export const OrdersContext = createContext(undefined as ContextType | undefined)

const OrdersProvider = ({ children }: ProviderProps) => {
  const [previewBatch, setPreviewBatch] = useState<BatchSnapshot[]>()

  return (
    <OrdersContext.Provider value={{ previewBatch, setPreviewBatch }}>
      {children}
    </OrdersContext.Provider>
  )
}

export default OrdersProvider
